// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__3zS9g","form-field":"Form_form-field__1nWLY","checkbox":"Form_checkbox___mA3i"};